<div class="subscriptionSchedulerModal modalOverlay" style="z-index:1600">
    <div class="modalPositioner newSubscriptionModal">
        <div class="modalContainer">
            <cv-loader *ngIf="validatingStep2" style="margin-left: -32px;" class="d-block" [overlay]="true" [size]="'medium'"></cv-loader>

            <!-- Header -->
            <button type="button" class="closeButton icon-btn fill-valyrianSteel fill-hover-whaleTail mt-1 mr-1"
                    (click)="clickCancel()">
                <svg class="icon-16">
                    <use href="../../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                </svg>
            </button>
            <div class="modalHeader">
                <div class="titleText" cvLocalizedText langSection="Create_Report_Subscription" langKey="Widget_Subscription">
                    Widget Subscription
                </div>
                <div class="FlexRowNoWrap SlideTypeStepNav">
                    <div class="SlideTypeNavBarStep FlexRowNoWrap" (click)="navigateToStep(1)">
                        <div class="mt-3">
                            <img src="../../../App_Themes/clearview-default/icons/number/circle-1.svg" />
                        </div>
                        <div class="steps" cvLocalizedText langSection="Create_Report_Subscription" langKey="Details"
                             [ngClass]="{'SlideTypeNavActiveStep': currentStep == 1, 'SlideTypeNavInactiveStep': currentStep != 1}">
                            Details
                        </div>
                        <div class="SlideTypeNavLine"></div>
                    </div>
                    <div class="SlideTypeNavBarStep FlexRowNoWrap" (click)="navigateToStep(2)">
                        <div class="mt-3">
                            <img src="../../../App_Themes/clearview-default/icons/number/circle-2.svg" />
                        </div>
                        <div class="steps" cvLocalizedText langSection="Create_Report_Subscription" langKey="Widget_Settings"
                             [ngClass]="{'SlideTypeNavActiveStep': currentStep == 2, 'SlideTypeNavInactiveStep': currentStep != 2}">
                            Widget Settings
                        </div>
                        <div class="SlideTypeNavLine"></div>
                    </div>
                    <div class="SlideTypeNavBarStep FlexRowNoWrap" (click)="navigateToStep(3)">
                        <div class="mt-3">
                            <img src="../../../App_Themes/clearview-default/icons/number/circle-3.svg" />
                        </div>
                        <div class="steps" cvLocalizedText langSection="Create_Report_Subscription" langKey="Export_Options"
                             [ngClass]="{'SlideTypeNavActiveStep': currentStep == 3, 'SlideTypeNavInactiveStep': currentStep != 3}">
                            Export Options
                        </div>
                    </div>
                </div>
            </div>

            <div class="modalBody" [ngSwitch]="currentStep">
                <!-- Step 1: Widget Name -->
                <ng-container *ngSwitchCase="1">
                    <div class="bodyRow newSubscriptionNameContainer">
                        <!-- Name -->
                        <div class="newSubscriptionNameContainer">
                            <div class="inputGroup">
                                <div class="inputTitle" cvLocalizedText langSection="Create_Report_Subscription" langKey="Name">Name</div>
                                <div class="inputValidation" [hidden]="validations.subscriptionName"
                                     cvLocalizedText langSection="Create_Report_Subscription" langKey="Set_Name"></div>
                                <div class="inputValidation" cvLocalizedText langSection="Create_Report_Subscription" langKey="Name_Too_Long"
                                     [hidden]="!validations.nameTooLong"></div>
                                <input class="form-control" cvLocalizedPlaceholder langSection="Create_Report_Subscription" langKey="Type_Name_Here"
                                       placeholder="Type name here" [(ngModel)]="subscriptionName" maxlength="35" />
                            </div>

                            <!-- Group/Folder -->
                            <div class="inputGroup marginTop16">
                                <div class="inputTitle" cvLocalizedText langSection="Create_Report_Subscription" langKey="Subscription_Folder">Subscription Folder</div>
                                <div class="inputValidation" cvLocalizedText langSection="Create_Report_Subscription" langKey="Set_Folder"
                                     [hidden]="validations.selectedGroup"></div>
                                <div class="inputValidation" cvLocalizedText langSection="Create_Report_Subscription" langKey="Folder_Too_Long"
                                     [hidden]="!validations.folderTooLong"></div>
                                <input class="form-control" list="reportSubscriptionCreateNewGroups" type="" langSection="Create_Report_Subscription" langKey="Select_Folder"
                                    cvLocalizedPlaceholder placeholder="Select folder" [(ngModel)]="selectedGroup" maxlength="35" />
                                <datalist id="reportSubscriptionCreateNewGroups">
                                    <option *ngFor="let group of groupKeys" value="{{group}}"></option>
                                </datalist>
                            </div>

                            <!-- Module -->
                            <div class="inputGroup marginTop16">
                                <div class="inputTitle" cvLocalizedText langSection="Create_Report_Subscription" langKey="Select_Widget">Select Widget</div>
                                <div class="inputValidation" cvLocalizedText langSection="Create_Report_Subscription" langKey="Set_Widget"
                                     [hidden]="validations.selectedModule"></div>

                                <!-- Not Edit Mode - Enabled, all options -->
                                <select name="ModuleSelector" class="form-control" *ngIf="editMode !== true" [ngClass]="{'placeholder': selectedModuleId == -1}"
                                        [(ngModel)]="selectedModuleId" (ngModelChange)="onModuleSelectionChange()">
                                    <option value="-1" style="background-color: white;" disabled selected hidden
                                            cvLocalizedText langSection="Create_Report_Subscription" langKey="Select_Widget">
                                        Select Widget
                                    </option>
                                    <option *ngFor="let module of subscribableElements" value="{{module.ModuleID}}">{{ module.LocalizedName }}</option>
                                </select>

                                <!-- Edit Mode - Disabled, display only the already-selected option -->
                                <select name="ModuleSelector" class="form-control" *ngIf="editMode === true" [disabled]="true">
                                    <option value="editObject.RelatedID" default>{{ editObject.RelatedName }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Step 2: Module Settings -->
                <ng-container *ngSwitchCase="2">
                    <cv-module-subscription-settings-container [selectedModule]="selectedModule" [moduleKey]="relatedKey"
                                                               [triggerApplySettings]="triggerApplySettings"
                                                               (settingsApplied)="onSettingsApplied($event)"
                                                               (settingsFailed)="onSettingsFailed($event)"></cv-module-subscription-settings-container>
                </ng-container>

                <!-- Step 3: Subscription Settings -->
                <ng-container *ngSwitchCase="3">
                    <div class="embeddedContent">
                        <cv-subscription-scheduler [embedMode]="true"
                                                   [relatedId]="relatedId"
                                                   [relatedKey]="relatedKey"
                                                   [reportType]="reportType"
                                                   [subscriptionId]="(editMode == true)? editObject.ID : -1"
                                                   [triggerSave]="startSaving"
                                                   (saved)="onSaved($event)"></cv-subscription-scheduler>
                    </div>
                </ng-container>
            </div>

            <!-- Footer -->
            <div class="modalFooter">
                <div class="buttonContainer">
                    <button type="button" class="btn btn-text mr-2" cvLocalizedText langSection="Create_Report_Subscription" langKey="Cancel_Button" (click)="clickCancel()">Cancel</button>
                    <button *ngIf="currentStep != 3" type="button" class="btn btn-primary" cvLocalizedText langSection="Create_Report_Subscription" langKey="Next_Button" (click)="nextStep()">Next</button>
                    <button *ngIf="currentStep == 3" type="button" class="btn btn-primary" cvLocalizedText langSection="Create_Report_Subscription" langKey="Save_Button" [disabled]="saving" (click)="clickSave()">Save</button>
                </div>
            </div>
        </div>
    </div>
</div>
